import styled from '@emotion/styled';
import React from 'react';

import { H3, theme } from '@kindur/components';

import withTracking from '../../components/Common/withTracking';
import colors from '../../styles/colors';
import image from '../../images/smartdraw/graph.svg';

const Container = styled('div')`
  align-items: center;
  background-color: ${colors.DarkGreen};
  color: #fff;
  display: flex;
  flex-flow: row nowrap;
  justify-content: stretch;
  ${theme.breakpoints.smallTabletDown} {
    height: auto;
    flex-flow: column nowrap;
  }
`;
const Padding = styled('div')`
  display: grid;
  grid-gap: 1rem 5rem;
  grid-template-columns: 1fr 1fr;
  padding: 4rem 24px;
  margin: 0 auto;
  max-width: 1200px;
  ${theme.breakpoints.tabletDown} {
    padding: 24px;
    text-align: left;

    * {
      grid-column-end: span 2;
    }
  }
`;
const Title = styled(H3)`
  color: #fff;
  font-family: 'DM Sans', sans-serif;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0.25px;
  line-height: 48px;
  margin: 0 0 16px;
  max-width: 10em;
  text-align: left;
  ${theme.breakpoints.tabletDown} {
    font-size: 24px;
    letter-spacing: 0.15px;
    line-height: 2rem;
    margin-bottom: 12px;
    max-width: unset;
  }
`;
const Copy = styled('h2')`
  font-family: 'DM Sans', sans-serif;
  font-size: 1.5rem;
  letter-spacing: 0.23px;
  line-height: 150%;
  max-width: 22em;
  ${theme.breakpoints.tabletDown} {
    font-size: 16px;
    line-height: 30px;
    max-width: unset;
  }
`;

const Description = styled('p')`
  font-family: 'DM Sans', sans-serif;
  max-width: 32em;
`;

const Image = styled('img')`
  max-width: 32rem;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;

  ${theme.breakpoints.tabletDown} {
    max-width: unset;
    position: static;
  }
`;

const Link = styled('a')`
  color: ${colors.White};
`;

const TrackComponentName = `SmartDrawDifference`;

const SmartDrawDifference = ({ content, track }) => {
  return (
    <React.Fragment>
      <Container>
        <Padding>
          <div style={{position: 'relative'}}>
            <Image src={image} alt={``} />
          </div>
          <div>
            <Title>{content.title}</Title>
            <Copy>SmartDraw creates personalized withdrawal strategies to help you earn up to $61,000+ in retirement.*</Copy>
            <Description>SmartDraw powers both the <Link href='https://silvur.app.link/KZkraVfqI5'>Silvur</Link> app and Kindur’s own financial products to help prolong your retirement income.</Description>
          </div>
        </Padding>
      </Container>
    </React.Fragment>
  );
};

SmartDrawDifference.displayName = TrackComponentName;

export default withTracking(SmartDrawDifference);
